const bodyItems = [
  {
    id: '345675',
    name: 'PERtinence Retrait',
    customerNumber: '52',
    kind: 'per',
    kindDetail: 'default',
    amount: '407180.38'
  },
  {
    id: '456787',
    name: 'Capitalisation Vie plus PP',
    customerNumber: '13',
    kind: 'capitalisation',
    kindDetail: 'default',
    amount: '589703.53'
  },
  {
    id: '654456',
    name: 'Patrimoine Vie Plus',
    customerNumber: '92',
    kind: 'lifeinsurance',
    kindDetail: 'default',
    amount: '778332.88'
  },
  {
    id: '567898',
    name: 'Avenir Vie Plus',
    customerNumber: '127',
    kind: 'lifeinsurance',
    kindDetail: 'default',
    amount: '214978.40'
  },
  {
    id: '324567',
    name: 'VIE PLUS IMPACT',
    customerNumber: '19',
    kind: 'lifeinsurance',
    kindDetail: 'default',
    amount: '520805.83'
  }
]

const product = {
  id: 'modelPortfolio'
}

const getDefaultState = () => {
  return {
    list: bodyItems,
    filters: {},
    product
  }
}

const state = getDefaultState()

export default () => ({
  state
})
